import React from 'react';
import { faShip } from '@fortawesome/free-solid-svg-icons';
import { WidgetRow, WidgetFooter, WidgetEmpty, Age, useGoTo } from './common';

const DeliveriesReviewWidget = ({ data }) => {
  const goTo = useGoTo();
  const items = data.items || [];
  return (
    <>
      {items.length === 0 && <WidgetEmpty>No deliveries are waiting for review.</WidgetEmpty>}
      {items.map((d) => {
        const parts = [d.number, d.submitted_by_name, d.comment_count ? `${d.comment_count} comment${d.comment_count === 1 ? '' : 's'}` : ''].filter(Boolean);
        return (
          <WidgetRow
            key={d.id}
            icon={faShip}
            tone="brand"
            title={d.vessel_name || d.number || 'Delivery'}
            subtitle={parts.join(' · ')}
            right={<Age>{d.age_label}</Age>}
            onClick={() => goTo(d.url)}
          />
        );
      })}
      <WidgetFooter label="Open Trade Operations" url={data.url} />
    </>
  );
};

export default DeliveriesReviewWidget;
